import { Alert, Box, Button, Paper, Stack, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePasswordResetMutation } from '../features/auth/passwordReset';

function useQuery() {
    const { search } = useLocation();
  
    return React.useMemo(() => new URLSearchParams(search), [search]);
}
  
const PasswordResetView = () => {
    const [errorMessage, setErrorMessage] = useState('')
    const [password, setPassword] = useState('')
    const [passwordVerify, setPasswordVerify] = useState('')
    const [passwordReset, result] = usePasswordResetMutation()
    let query = useQuery();

    const username = query.get("user").replace("_AT_", "@")
    const token = query.get("token")

    if(result.isSuccess) {
        return <Navigate to="/login" />
    }

    const handleReset = (e) => {
        e.preventDefault()
        if(password != passwordVerify) {
            setErrorMessage("Passwords don't match!")
            return
        }
        passwordReset({
            username: username,
            reset_token: token,
            password: password
        })
        setErrorMessage("Password reset in progress.")
    }

    return <center>
    <Box sx={{margin: 2}}>
        <Paper sx={{padding: 2}}>
            <Stack spacing={1}>
            <Typography variant="h2" gutterBottom>Reset password</Typography>
            {errorMessage ? <Alert severity="error" className={errorMessage ? "errmsg" : "offscreen"} aria-live="assertive">{errorMessage}</Alert> : ""}
            <form onSubmit={handleReset}>
                <TextField type="password" id="password" value={password} onChange={(e) => {setPassword(e.target.value)}} label="Password" required /><br /><br />
                <TextField type="password" id="passwordVerify" value={passwordVerify} onChange={(e) => {setPasswordVerify(e.target.value)}} label="Verify Password" required /><br /><br />
                <Button type="submit" variant="contained">Change password</Button>
            </form>
            </Stack>
        </Paper>
    </Box>
    </center>

}

export default PasswordResetView;
